<ion-header>
    <ion-toolbar>
        <ion-title data-test="title">Campaign Opt In/Out</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <ion-list class="ion-padding">
        <ion-label ion-text-wrap>
            Hello {{customer.customerName}},<br /><br />

            @if (customer.isActive==true) {
  <div>
                You are currently signed up to receive the monthly incentives.
                Click the button below to stop receiving these incentives.       
            </div>
}

            @if (customer.isActive==false) {
  <div>
                You are not currently signed up to receive the monthly incentives.
                Click the button below to receive these incentives.
            </div>
}
        </ion-label>
    </ion-list>
</ion-content>

<ion-footer>
    @if (customer.isActive==true) {
  <ion-toolbar>
        <ion-button data-test="optOut" color="primary" expand="full" (click)="onOptoutClick()">Please stop sending me incentives</ion-button>
    </ion-toolbar>
}
    @if (customer.isActive==false) {
  <ion-toolbar>
        <ion-button data-test="optIn" color="primary" expand="full" (click)="onOptoutClick()">Please send me the incentives</ion-button>
    </ion-toolbar>
}
</ion-footer>